import script from "./CatalogItemActions.vue?vue&type=script&setup=true&lang=ts"
export * from "./CatalogItemActions.vue?vue&type=script&setup=true&lang=ts"

import "./CatalogItemActions.vue?vue&type=style&index=0&id=d1e018d4&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d1e018d4"]])

export default __exports__